export const validationMessages = {
    mixed: {
        required: ({label}: { label: string }) => `${label} is verplicht`,
        default: ({label}: { label: string }) => `${label} is ongeldig`,
    },
    string: {
        min: ({label, min}: { label: string; min: number }) => `${label} moet minimaal ${min} karakters bevatten`,
        max: ({label, max}: { label: string; max: number }) => `${label} mag maximaal ${max} karakters bevatten`,
        matches: ({label}: { label: string }) => `${label} heeft een ongeldig formaat`,
    },
} as const;